// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lJhF5","newExpiryDate":"styles_newExpiryDate__n6YR0","footer":"styles_footer__2ljh3"};